var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 3L10.3422 2.1811C9.85896 1.37578 9.05867 0.806961 8.12706 0.688205C7.36578 0.591162 6.39131 0.5 5.41683 0.5C4.73676 0.5 4.0567 0.544399 3.4491 0.60421C2.1099 0.736039 1.09972 1.78017 0.996805 3.1219C0.909627 4.2584 0.833496 5.86274 0.833496 8C0.833496 9.51712 0.888736 10.8685 0.958988 11.9737C1.07646 13.8219 2.5136 15.2446 4.36238 15.3512C5.76652 15.4321 7.64578 15.5 10.0002 15.5C12.3545 15.5 14.2338 15.4321 15.6379 15.3512C17.4867 15.2446 18.9239 13.8219 19.0413 11.9737C19.1116 10.8685 19.1668 9.51712 19.1668 8C19.1668 7.13239 19.1166 6.31496 19.0511 5.61737C18.9252 4.2776 17.8892 3.24158 16.5495 3.11572C15.8519 3.05018 15.0344 3 14.1668 3H10.8335Z",
    fill: "var(--text-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/icon-folder.39d824a85a55f50064e02fdf314a0a71.svg";
export { ForwardRef as ReactComponent };